import { CanDeactivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { Observable } from 'rxjs';
import { UnsavedTrackingService } from '../../services/unsaved-changes.service';

export const unsavedChangesGuard: CanDeactivateFn<any> = (component) => {

  // Skip guard during session timeout logout
  if (sessionStorage.getItem('isLoggingOut') === 'true') {
    return true;
  }

  const confirmationService = inject(ConfirmationService);
  const unsavedService = inject(UnsavedTrackingService);

  const form =
    component.profileForm ||
    component.signupForm ||
    component.voucherForm;

  // No form
  if (!form) {
    return true;
  }

  // No actual changes compared to registered form
  if (!unsavedService.hasChanges(form)) {
    return true;
  }

  // Default dialog
  let header = 'Unsaved Changes';
  let message =
    'You have unsaved changes. Are you sure you want to leave? Your progress will be lost.';
  let acceptLabel = 'Leave';
  let rejectLabel = 'Continue Editing';

  // Custom message for Voucher Setup
  if (component.voucherForm) {
    header = 'Warning!';
    message =
      'This action will take you out of the voucher setup and your progress will not be saved. Are you sure you want to leave?';

    acceptLabel = 'Leave Setup';
    rejectLabel = 'Continue Setup';
  }

  return new Observable<boolean>((observer) => {

    confirmationService.confirm({
      header,
      message,
      acceptLabel,
      rejectLabel,

      accept: () => {
        observer.next(true);
        observer.complete();
      },

      reject: () => {
        observer.next(false);
        observer.complete();
      }
    });

  });
};